export const SwitchV2TestId = {
  Input: "SwitchV2-input",
};
